import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Webcam } from '../models/webcam.model';
import { WebcamService } from '../services/webcam.service';


@Component({
  selector: 'app-edit-webcam',
  templateUrl: './edit-webcam.component.html',
  styleUrls: ['./edit-webcam.component.scss']
})
export class EditWebcamComponent implements OnInit {
  webcam: Webcam;
  origWebcam: Webcam;
  isNew = false;
  isLoading = true;
  businessID: number;
  itemsToChange: Set<number>;
  formGroup: FormGroup;
  selectedName: string;
  selectedSite: string;
  selectedFacing: string;
  selectedUrl: string;


  constructor(private _matDialogRef: MatDialogRef<EditWebcamComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data,
              private _webcamService: WebcamService) {
    this.webcam = data.webcam || new Webcam();
    this.isNew = data.isNew || false;
    this.businessID = data.busID;
    this.origWebcam = Object.assign(new Webcam(), data.webcam);
    this.itemsToChange = new Set<number> ();
    this.selectedName = this.webcam.name;
    this.selectedSite = this.webcam.site;
    this.selectedFacing = this.webcam.direction;
    this.selectedUrl = this.webcam.url;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      name: new FormControl(this.selectedName, [Validators.required, Validators.maxLength(100)]),
      url: new FormControl(this.selectedUrl, [Validators.required, Validators.maxLength(200),
    Validators.pattern(
  '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$'
    )]),
      site: new FormControl(this.selectedName, [Validators.required, Validators.maxLength(100)]),
      facing: new FormControl(this.selectedFacing, [Validators.required, Validators.maxLength(30)])
    });
    this.isLoading = false;
  }

  /**
   * triggered by save button click event
   * @return {Promise<void>}
   */
  async save() {
    try {
      let res: any;
      this.webcam.url = this.formGroup.value.url;
      this.webcam.name = this.formGroup.value.name;
      this.webcam.site = this.formGroup.value.site;
      this.webcam.direction = this.formGroup.value.facing;
      if (this.isNew) {
        res = await this._webcamService.postWebcam(this.businessID, this.webcam);
        this.webcam = Webcam.parse(res);
      } else {
        res = await this._webcamService.putWebcam(this.businessID, this.webcam);
        Object.assign(this.webcam, Webcam.parse(res));
        this.webcam = Webcam.parse(res);
      }
      this.close({cancelBtnClicked: false, success: true, webcam: this.webcam});
    } catch (e) {
      this.close({cancelBtnClicked: false, success: false});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    if (data && data.cancelBtnClicked) {
      Object.assign(this.webcam, this.origWebcam);
    }
    data['isNew'] = this.isNew;
    this._matDialogRef.close(data);
  }
}
